import React from 'react';
import Typography from '@mui/material/Typography';

const FedColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Control Name</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Baseline</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Identification</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Family</Typography>
      </div>
    </>
  );
};

export default FedColumns;
